import React from "react";
import { reportClientError } from "@/lib/errorReporter";

// Item 8 (2026-07): top-level error boundary — a render crash shows a
// friendly card instead of a silent white page.
//
// 2026-07-29: reporting moved off the pageview beacon. Errors used to be filed
// as a fake path (`/__client-error: ...`) among real traffic, which recorded
// them somewhere nobody would ever look — the same outcome as not recording
// them. They now go to their own endpoint with an admin view.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[error-boundary]", error, info?.componentStack);
    reportClientError(error?.message || error, "render");
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-card" className="min-h-[70vh] flex items-center justify-center px-6">
          <div className="bg-white border border-neutral-200 rounded-2xl p-10 max-w-md text-center shadow-sm">
            <div className="font-display text-2xl text-forest">Something went wrong</div>
            <p className="text-neutral-600 text-sm mt-3">
              An unexpected error stopped this page from rendering. Reloading usually fixes it.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center justify-center rounded-full bg-forest hover:bg-forest-hover text-white h-11 px-8 text-sm font-medium transition-colors"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
